import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsNvidiaComponent } from './simple-icons-nvidia.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsNvidiaComponent ],
    exports:      [ SimpleIconsNvidiaComponent ],
    bootstrap:    []
})
export class SimpleIconsNvidiaModule {}
